import { Footer } from 'modules/Footer'
import { Header } from 'modules/Header'
import { Layout } from 'modules/layouts'
import React from "react";


export const Landing = () => {
  return (
    <>
      <Header />
      <Layout.Main />
      <Layout.About />
      <Layout.Benefits />
      <Layout.KindFuel />
      <Layout.Certificates/>
      <Layout.FindUs />
      <Layout.Bonuses />
      <Layout.BonusesProgramme />
      <Layout.FAQ />
      <Layout.Contacts />
     
      <Footer /> 
    </>
  )
}
